
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // メニューが開いている時はスクロールを無効化
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const scrollToSection = (sectionId: string) => {
    setIsMenuOpen(false);
    if (location.pathname !== '/') {
      window.REACT_APP_NAVIGATE('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || isMenuOpen ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-8 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer" onClick={handleLinkClick}>
            <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
              <i className="ri-settings-3-line text-2xl text-white"></i>
            </div>
            <span className="text-xl font-black text-gray-900 whitespace-nowrap">
              ECオートパイロットOS
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('problems')}
              className="text-gray-700 hover:text-primary font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              課題
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-primary font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              サービス
            </button>
            <Link
              to="/amazon-automation"
              className="text-gray-700 hover:text-primary font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              Amazon自動化
            </Link>
            <Link
              to="/company"
              className="text-gray-700 hover:text-primary font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              会社概要
            </Link>
            <button
              onClick={() => scrollToSection('pricing')}
              className="text-gray-700 hover:text-primary font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              料金
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-primary text-white px-6 py-2 rounded-lg font-bold hover:bg-primary-dark transition-all whitespace-nowrap cursor-pointer"
            >
              無料相談
            </button>
          </nav>
          
          {/* モバイルメニューボタン */}
          <button 
            className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* モバイルメニュー */}
      <div 
        className={`md:hidden fixed inset-0 top-[72px] bg-white z-40 transition-all duration-300 ${
          isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <nav className="flex flex-col p-6 gap-2">
          <button
            onClick={() => scrollToSection('problems')}
            className="text-gray-700 hover:text-primary hover:bg-gray-50 font-medium transition-colors py-4 px-4 text-left rounded-lg cursor-pointer"
          >
            課題
          </button>
          <button
            onClick={() => scrollToSection('services')}
            className="text-gray-700 hover:text-primary hover:bg-gray-50 font-medium transition-colors py-4 px-4 text-left rounded-lg cursor-pointer"
          >
            サービス
          </button>
          <Link
            to="/amazon-automation"
            onClick={handleLinkClick}
            className="text-gray-700 hover:text-primary hover:bg-gray-50 font-medium transition-colors py-4 px-4 text-left rounded-lg cursor-pointer"
          >
            Amazon自動化
          </Link>
          <Link
            to="/company"
            onClick={handleLinkClick}
            className="text-gray-700 hover:text-primary hover:bg-gray-50 font-medium transition-colors py-4 px-4 text-left rounded-lg cursor-pointer"
          >
            会社概要
          </Link>
          <button
            onClick={() => scrollToSection('pricing')}
            className="text-gray-700 hover:text-primary hover:bg-gray-50 font-medium transition-colors py-4 px-4 text-left rounded-lg cursor-pointer"
          >
            料金
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="bg-primary text-white px-6 py-4 rounded-lg font-bold hover:bg-primary-dark transition-all text-center mt-4 cursor-pointer whitespace-nowrap"
          >
            無料相談
          </button>
        </nav>
      </div>
    </header>
  );
}
